import { render } from "./CompoStep1.vue?vue&type=template&id=aa399b5e"
import script from "./CompoStep1.vue?vue&type=script&lang=js"
export * from "./CompoStep1.vue?vue&type=script&lang=js"

import "./CompoStep1.vue?vue&type=style&index=0&id=aa399b5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__